const defaultState = {};

export default function instagramReducer(state = defaultState, action) {
  switch (action.type) {
    case 'FETCH_IG_INITIATED': {
      return {
        ...state,
        is_fetching: true,
      };
    }
    case 'FETCH_IG_COMPLETED': {
      return {
        ...state,
        is_fetching: false,
        [action.id]: {
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
}
